export enum StCryptographyType {
  ASYMMETRIC,
  SYMMETRIC,
}
